import VideoSequence from "@/components/base/VideoSequence";
import Character from "@/components/partials/Character";

export default {
	components: {
		Character,
		VideoSequence,
	},
	props: {
		content: {
			required: true,
			type: String,
		},
		transitions: {
			required: false,
			type: Object,
			default: () => ({
				entering: "speaking",
			}),
		},
		buttons: {
			required: false,
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			state: "entering",
			videoEndHandler: () => {},
		};
	},
	methods: {
		pushState(state, callback = () => {}) {
			this.state = state;
			this.setVideoEndHandler(callback);
		},
		setVideoEndHandler(callback) {
			this.videoEndHandler = () => {
				callback();
				this.videoEndHandler = () => {};
			};
		},
	},
};



// WEBPACK FOOTER //
// ./src/mixins/character.mixins.js